import script from "./cardDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./cardDetail.vue?vue&type=script&setup=true&lang=js"

import "./cardDetail.vue?vue&type=style&index=0&id=db45779a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db45779a"]])

export default __exports__